export default "__VITE_ASSET__JdOrz6Yx__"